<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import UsersApi from "@/services/users-api";
import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Profil",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout},
  mounted(){
    this.isSupplier = sessionStorage.getItem("userr") == 1;
    this.role= sessionStorage.getItem("userr")
    this.getLogin()
    if(sessionStorage.getItem("userr") ==0 || sessionStorage.getItem("userr") == 1){
      this.getProfilInfo()
    }   
  },
  data() {
    return {
      isSupplier:null,
      profilInfo : {
        name:'',
        address:'',
        phone:'',
        secondPhone:'',
        mail:'',
        bank:'',
        rib:'',
        taxRefNumber: '',
        webSite:'',
        facebook:'',
        linkedIn:'',
        logo:'',
        contacts: [],
      },
      login:'',
      oldPassword:'',
      newPassword:'',
      confirmationPassword:'',
      changeLogo:null,
      showContactModal:false,
      showForm:false,
      selectedContact: {id:'', firstName:'', lastName:'', phone:'', email:'', position:'' },
      role:null,
    };
  },
  methods:{
    getLogin(){
      UsersApi.getLogin().then(
        result => {
          this.login=result
        }
      )
    },

    ChangePassword() {
      UsersApi.ChangePassword(this.oldPassword, this.newPassword, this.confirmationPassword)
      .then(
        result => {
          if (result) {
            this.oldPassword = '';
            this.newPassword = '';
            this.confirmationPassword = '';
          }
        }
      )
    },

    getProfilInfo(){
      UsersApi.getProfilInfo().then(
        result => {
          this.profilInfo=result;
        }
      )
    },
    changeProfilInfo(){
      Swal.fire({
      title:  'Modifier' ,
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      cancelButtonText: "Annuler",
      confirmButtonText: 'Oui, modifier' 
      }).then(result => {
          if (result.value) {
              UsersApi.changeProfilInfo(this.profilInfo)
          }
      })
    },
        
    onImageUpload(event) {
        this.changeLogo=event.target.files[0];
        this.uploadImage() 
    },

    uploadImage(){
      const fd = new FormData();
      fd.append('file', this.changeLogo, this.changeLogo.name)
      UsersApi.uploadImage(fd).then(
        res => {
          if(res){
            this.getProfilInfo()
          }
        }
      )
    },

    deleteImage() {
      Swal.fire({
          title: "Supprimer votre logo ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Annuler",
          confirmButtonText: "Oui, supprimer!"
      }).then(result => {
          if (result.value) {
              UsersApi.deleteImage()
              .then(() =>{
                   this.getProfilInfo()
                  }) 
          }
      })
    },
    addNew(){
      this.showForm =true;
    } ,
    hideForm(){
      this.showForm =false;
    },
    cancelEdit(){
      this.selectedContact.id=null
      this.selectedContact.firstName=''
      this.selectedContact.lastName=''
      this.selectedContact.phone=''
      this.selectedContact.email=''
      this.selectedContact.position=''
    },
    editContact(contact){
      this.showForm =true;
      this.cancelEdit();
      this.selectedContact.id=contact.id
      this.selectedContact.firstName=contact.firstName
      this.selectedContact.lastName=contact.lastName
      this.selectedContact.phone=contact.phone
      this.selectedContact.email=contact.email
      this.selectedContact.position=contact.position
    },
    saveContact(){
      UsersApi.saveContact(this.selectedContact).then(
        ()=> {
          this.getProfilInfo()
          this.cancelEdit()
          this.hideForm()
        }
      )
    },

    removeContact(contact){
      Swal.fire({
        title: "Supprimer ?",
        html: contact.firstName+' '+contact.lastName,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer!"
    }).then(result => {
        if (result.value) {
            UsersApi.removeContact(contact)
            .then(() =>{
                  this.getProfilInfo()
                }) 
        }
    })

    },

  }
}
</script>
<template>
    <Layout>
      <div class="row  p-4">
        <div class="col-12 card border border-light h-100">
          <div class="card-body">
            <h4 class="card-title pt-2 pb-4 text-primary font-size-18 ">Modification du Mot de Passe</h4>
                <div class="row">
                  <b-form class="col-12">
                    <div class="form-group row mb-3">
                        <label class="col-md-3 col-form-label" for="name" >Utilisateur</label>
                        <div class="col-md-9">
                          <input type="text" name="login" class="form-control" style="background-color: #f0f3ec;" v-model="login" disabled/>
                        </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="pwd">Ancien mot de passe</label>
                      <div class="col-md-9">
                        <input
                          id="Oldpwd"
                          type="password"
                          v-model="oldPassword"
                          class="form-control"
                          autocomplete="off"
                        />
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="pwd">Nouveau mot de passe</label>
                      <div class="col-md-9">
                        <input
                          id="Newpwd"
                          type="password"
                          v-model="newPassword"
                          class="form-control"
                          autocomplete="off"
                        />
                      </div>
                    </div>

                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="confirmpwd">Confirmation du mot de passe</label>
                      <div class="col-md-9">
                        <input
                          id="confirmpwd"
                          type="password"
                          v-model="confirmationPassword"
                          class="form-control"
                          autocomplete="off"
                        />
                      </div>
                    </div>
                    <div class="row mt-4 mb-0" style="float: right; text-align: right;">
                      <b-button  class="ml-2 " variant="primary" style="display: inline-block" @click="ChangePassword()" >Enregistrer</b-button>
                    </div>                    
                  </b-form>
                  <!-- end col -->
                </div>
                <!-- end row -->
          </div>
        </div>
      </div>
      <div v-if="this.role==0 || this.role==1" class="row pl-4 pr-4 pt-2 pb-2" >
        <div class="col-12 card border border-light h-100">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                  <h4 class="card-title pt-2 pb-4 text-primary font-size-18 ">Votre Organisme</h4>
              </div>
              <div  class="col-sm-4"/>
 
              <div class="col-sm-4">
                <img v-if="this.isSupplier" @click="$refs.imageInput.click()" v-bind:src="'/api/image/get/' + profilInfo.logo" alt height="80" width="120" class="float-right pb-2 p-0 m-0" style="cursor: pointer;" /> 
              </div>
            </div>
            <div v-if="this.isSupplier"  class="row pb-3">
              <div class="col-sm-11"/>
              <div class="col-sm-1 ">
                  <!-- <a  title="modifier" class="d-none d-lg-block"  href="javascript:void(0);"  @click="$refs.imageInput.click()">
                    <i class="fas fa-edit text-primary float-sm-left p-0 pl-4 pr-4"></i>   
                  </a> -->
                  <a title="supprimer" href="javascript:void(0);" @click="deleteImage()">
                    <i class="fas fa-trash text-danger float-right p-0 pr-4 pl-4  "></i> 
                  </a>
              </div> 

              <input 
              type="file" 
              @change="onImageUpload"
              ref="imageInput"
              style="display:none"/>

            </div>

            
                <div class="row">
                  <div class="col-12">
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="name">Nom Commercial</label>
                      <div class="col-md-9">
                        <input type="text" name="name" class="form-control" v-model="profilInfo.name" />
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="name">Nom de l'Organisme</label>
                      <div class="col-md-9">
                        <input type="text" name="name" class="form-control" v-model="profilInfo.legalName" />
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="adress">Adresse</label>
                      <div class="col-md-9">
                        <input type="text" name="surname" class="form-control" v-model="profilInfo.address"  />
                      </div>
                    </div>

                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="phone" >Numéros de Téléphone</label>
                      <div class="col-md-4 ">
                        <input
                          type="text"
                          name="phone"
                          class="form-control"
                          v-model="profilInfo.phone"
                          placeholder="Téléphone 1"
                        />
                      </div>
                      <div class="col-md-1"/>
                      <div class="col-md-4">
                        <input
                          type="text"
                          name="phone"
                          class="form-control"
                          v-model="profilInfo.secondPhone"
                          placeholder="Téléphone 2"
                        />
                      </div>
                    </div>

                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="rib">E-Mail</label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          name="rib"
                          class="form-control"
                          v-model="profilInfo.mail"                        
                        />
                      </div>
                    </div>

                    <div  class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="rib">Matricule Fiscal</label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          name="rib"
                          class="form-control"
                          v-model="profilInfo.taxRefNumber"                        
                        />
                      </div>
                    </div>

                    <div v-if="this.isSupplier" class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="phone">Banque et RIB</label>
                      <div class="col-md-2 ">
                        <input
                          type="text"
                          name="phone"
                          class="form-control"
                          placeholder="Banque"
                          v-model="profilInfo.bank"
                        />
                      </div>
                      <div class="col-md-7 pl-sm-2">
                        <input
                          type="text"
                          name="phone"
                          class="form-control"
                          placeholder="RIB"
                          v-model="profilInfo.rib"
                        />
                      </div>
                    </div>

                    <div v-if="this.isSupplier"  class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="webSite">Site Web</label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          name="website"
                          class="form-control"
                          v-model="profilInfo.webSite" 
                          placeholder="Le URL doit commencer par https://"                       
                        />
                      </div>
                    </div>

                    <div v-if="this.isSupplier" class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="facebook">Facebook</label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          name="facebook"
                          class="form-control"
                          v-model="profilInfo.facebook"   
                          placeholder="Le URL doit commencer par https://"                       
                        />
                      </div>
                    </div>

                    <div v-if="this.isSupplier" class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="linkedIn">Instagram</label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          name="instagram"
                          class="form-control"
                          v-model="profilInfo.instagram"
                          placeholder="Le URL doit commencer par https://"                       
                        
                        />
                      </div>
                    </div>

                    <b-form-group v-if="!this.isSupplier"> 
                      <div class="row mt-4">
                        <label class="col-md-3 col-form-label" for="phone">Annuaire LGP</label>
                            <b-form-checkbox
                            value="true"
                            unchecked-value="false"
                            class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                            v-model="profilInfo.isDirectoryAuthorized">
                            <span :class="profilInfo.isDirectoryAuthorized == 'true' || (profilInfo.isDirectoryAuthorized == true) ? 'text-muted' : 'text-danger'" > Nous autorisons l'affichage de l'officine dans l'annuaire de la Plateforme. </span>
                            </b-form-checkbox>
                          </div>
                  </b-form-group>

                    <b-form-group v-if="!this.isSupplier"> 
                      <div class="row">
                          <label class="col-md-3 col-form-label" for="phone">Pharmacie de :</label>
                          <div class="custom-control custom-radio custom-control-inline mt-2 m-0 p-0">
                              <b-form-radio v-model="profilInfo.type"  value="0">Jour</b-form-radio>
                          </div>

                          <div class="custom-control custom-radio custom-control-inline mt-2 m-0 p-0 ml-4 ">
                              <b-form-radio v-model="profilInfo.type"   value="1">Nuit</b-form-radio>
                          </div>
                      </div>
                  </b-form-group>

                    <b-button v-if="this.isSupplier" 
                        variant="link"
                        class="p-0 m-0 pt-3  text-primary font-weight-bold font-size-14" 
                        @click="showContactModal = true"
                        >
                        <i class="fas fa-edit " ></i>
                        <span class="ml-2">Editer les representants</span>
                    </b-button>

                    <div class="row" style="float: right; text-align: right;">
                      <b-button  class="ml-2 " variant="primary" style="display: inline-block" @click="changeProfilInfo()">Enregistrer</b-button>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
          </div>
          <!-- end card-body -->
        </div>
      </div>

      <b-modal v-if="this.isSupplier"  v-model="showContactModal"
        title="Editer les representants" 
        hide-footer 
        centered 
        title-class="text-warning"
        title-tag="h5"
        header-close-variant="danger"
        size="lg">
         <div class="zoom-container">
          <b-button
            variant="link"
            class="p-0 m-0 pb-3  text-primary font-weight-bold font-size-14 float-right" 
            @click="addNew()"
            >
            <i class="fas fa-edit " ></i>
            <span class="ml-2">Ajouter Nouveau</span>
        </b-button>
        <div v-if="showForm" class="row mt-4" style="width:100%">
            <div class="form-group col-sm-2 pr-2">
              <label >Prénom</label>
              <input
                type="text"
                class="form-control"
                v-model="selectedContact.firstName"
              />
            </div>
            <div class="form-group col-sm-2 pr-2">
              <label >Nom</label>
              <input
                type="text"
                class="form-control"
                v-model="selectedContact.lastName"

              />
            </div>
            <div class="form-group col-sm-2 pr-2">
              <label >Téléphone</label>
              <input
                type="text"
                class="form-control"
                v-model="selectedContact.phone"
              />
            </div>

            <div class="form-group col-sm-2 pr-2">
              <label >E-mail</label>
              <input  type="email" class="form-control"
              v-model="selectedContact.email"
              />
            </div>

            <div class="form-group col-sm-2 pr-2">
              <label >Position</label>
              <input
                type="text"
                class="form-control"
                v-model="selectedContact.position"
              />
            </div>
          <div class="col-sm-2" style="padding-top:26px; padding-bottom:26px;">
            <b-button variant="secondary" @click="cancelEdit();hideForm();" class="mr-2" >
                <i class="fas fa-times font-size-14 align-middle  " ></i>
            </b-button>
            <b-button variant="success" @click="saveContact()" >
              <i class="fas fa-save font-size-14 align-middle  " ></i>
            </b-button>
        </div>
        </div>
        <div class="table-responsive" style="height:250px;" >
        <table class="table table-centered " >
          <thead class="thead-light">
            <tr>
              <th class="text-left">Prénom</th>
              <th class="text-left">Nom</th>
              <th class="text-left">Téléphone </th>
              <th class="text-left">Email</th>
              <th class="text-left">Position</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="contact in profilInfo.contacts" :key="contact.id" >
                  <td>{{contact.firstName}}</td>
                  <td>{{contact.lastName}}</td>
                  <td>{{contact.phone}}</td>
                  <td>{{contact.email}}</td>
                  <td>{{contact.position}}</td>
                  <td>
                    <a  title="modifier" href="javascript:void(0);"  @click="editContact(contact)" class="action-icon text-warning pr-2" >
                        <i class="mdi mdi-pencil font-size-22"  />
                    </a>

                    <a  title="supprimer" href="javascript:void(0);"  @click="removeContact(contact)" class="action-icon text-danger " >
                        <i class="mdi mdi-trash-can font-size-22 " />
                    </a>
                </td>
              </tr>
          </tbody>
        </table>
        <span v-if="!this.profilInfo.contacts.length " class="d-flex justify-content-center m-4 text-danger" >Aucun contact dans la liste</span>

        </div>
         </div>
</b-modal>
    </Layout>
</template>